/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface CopyMailTemplateRequest
 */
export interface CopyMailTemplateRequest {
  /**
   *
   * @type {string}
   * @memberof CopyMailTemplateRequest
   */
  sourceId?: string
}

export function CopyMailTemplateRequestFromJSON(json: any): CopyMailTemplateRequest {
  return CopyMailTemplateRequestFromJSONTyped(json, false)
}

export function CopyMailTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopyMailTemplateRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    sourceId: !exists(json, 'source_id') ? undefined : json['source_id']
  }
}

export function CopyMailTemplateRequestToJSON(value?: CopyMailTemplateRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    source_id: value.sourceId
  }
}
